import {
  EnableStatus,
  OperateAdvanceFundAddStatus,
  OperateAdvanceFundPayStatus,
  OperateFlowBizType,
  OperateKdcsApproveStatus,
  OperateSimpleApproveStatus,
  OperateStoreQuitClearStatus,
  OpStoreRiskStatus,
  SystemStoreParamsAddStatus,
  YesNo,
  OperateAuditStatus,
  OperateSettleStatus,
  OpSatCollectionPointStatus,
  OpSatCollectionPointStyles,
  OperateWaybillType,
  OpMarginStatus,
  OperateType,
  ComplainWorkorderStatus,
  ComplainDegreeUrgency,
  ComplainConsumerChannel,
  ComplainConsumerStatus,
  QcpComputeType,
  TodoTaskJumpModel,
  ActivityStatus,
  AgentLevel,
  DebitStatus,
  AftermarketWorkOrderStatus,
  AftermarketWorkOrderLevel,
  SalesOrderStatus,
  ReturnOrderStatus,
  BossSettleZTAuditStatus,
  BossSettleZTOrderStatus,
  BossSettleZTSettleStatus,
  PhoneCallStatus,
  BlackListDataSource,
  ActivityPlace,
  ActivityBizType,
  ActivityJumpType,
  CouponBusinessCat,
  CouponBusinessScene,
  CouponType,
  CouponGrantType,
  ZdsActivityType, DiscountMethodType
} from './enums'

import { getNumberRangeDataOptions } from '@/utils'

export const commonOptions = {
  //保证金明细交易类型
  payActions: [
    { label: '充值', value: 0 },
    { label: '提现', value: 1 },
    { label: '扣款', value: 2 }
  ],
  //保证金明细交易状态
  payStatuses: [
    { label: '交易成功', value: 1 },
    { label: '交易失败', value: -1 }
  ],

  // 是否
  yesOrNo: [
    { label: '是', value: YesNo.YES },
    { label: '否', value: YesNo.NO }
  ],

  // 启用禁用
  enableStatus: [
    { label: '启用', value: EnableStatus.ENABLE },
    { label: '禁用', value: EnableStatus.DISABLE }
  ],

  // 优惠券业务类型
  couponBusinessCat: [
    { label: '酒店住宿', value: CouponBusinessCat.LL_HOTEL, scene: CouponBusinessScene.LIANLIAN },
    { label: '游乐票务', value: CouponBusinessCat.LL_TICKET, scene: CouponBusinessScene.LIANLIAN },
    { label: '包裹险', value: CouponBusinessCat.INSURANCE_PACKAGE, scene: CouponBusinessScene.INSURANCE },
    { label: '财产&公责险', value: CouponBusinessCat.INSURANCE_PROPERTY, scene: CouponBusinessScene.INSURANCE }
  ],

  // 优惠券类型
  couponType: [
    { label: '直减', value: DiscountMethodType.ZHIJIAN },
    { label: '统一折扣', value: DiscountMethodType.DISCOUNT, couponType: [CouponBusinessScene.FILM] },
  ],



  // 门户------------------------
  // 达标状态
  achievementStandardsStatusOptions: [
    { label: '达标', value: 1 },
    { label: '未达标', value: 0 }
  ],

  // 补贴状态
  allowanceStatus: [
    { label: '未申请', value: 0 },
    { label: '补贴中', value: 1 },
    { label: '已补贴', value: 2 },
    { label: '审核中', value: 3 },
    { label: '已拒绝', value: -30 }
  ],

  // 运营平台------------------------
  //工单类型
  opWorkOrderTypes: [
    { label: '巡检类', value: 1 },
    { label: '客服类', value: 2 },
    { label: '商业类', value: 3 },
    { label: '运营类', value: 4 },
    { label: '舆情类', value: 5 },
    { label: '流失类', value: 7 },
    { label: '设备回收类', value: 8 },
    { label: '其他类', value: 6 }
  ],
  // 门店装修认证类型
  // 认证类型 1装修认证、2装修升级
  opStoreTypes: [
    { label: 'A', value: 'A', decorateAuthType: [1, 2] },
    { label: 'B', value: 'B', decorateAuthType: [1, 2] },
    { label: 'C', value: 'C', decorateAuthType: [1, 2] },
    { label: 'D', value: 'D', decorateAuthType: [1, 2] },
    { label: 'E', value: 'E', decorateAuthType: [1] },
    { label: 'F', value: 'F', decorateAuthType: [1] },
    { label: 'G', value: 'G', decorateAuthType: [1] },
    { label: 'H', value: 'H', decorateAuthType: [1] }
  ],
  // 装修形象特批的装修类型
  opRenovationTypes: [
    { label: 'A', value: 'A' },
    { label: 'B', value: 'B' },
    { label: 'C', value: 'C' },
    { label: 'D', value: 'D' },
    { label: 'E', value: 'E' },
    { label: 'F', value: 'F' },
    { label: 'G', value: 'G' },
    { label: 'H', value: 'H' },
    { label: 'Y', value: 'Y' }
  ],
  // 装修形象特批的门头材质
  opDoorMaterials: [
    { label: '亚克力', value: '亚克力' },
    { label: '铝塑板', value: '铝塑板' },
    { label: '灯箱布', value: '灯箱布' },
    { label: '其他', value: '其他' }
  ],
  //工单状态
  opWorkOrderStatus: [
    { label: '待接单', value: 0 },
    { label: '未完成', value: 99 },
    { label: '已超时', value: 2 },
    { label: '已完成', value: 1 },
    { label: '异常上报', value: 3 },
    { label: '待审核', value: 10 },
    { label: '已归档', value: 17 },
    { label: '超时已归档', value: 15 },
    { label: '异常已归档', value: 16 }
  ],
  //配置类型
  opConfigurationTypes: [
    { label: '按省市区下发', value: 0 },
    { label: '按门店编号下发', value: 2 }
  ],

  // 优惠券业务场景
  couponBusinessScene: [
    {
      label: '电影票',
      value: CouponBusinessScene.FILM,
      grantType: [
        CouponGrantType.TICKET,
        CouponGrantType.PHONE_NUMBER,
        CouponGrantType.USER_ID,
        CouponGrantType.COUPON_BAG
      ]
    },
    {
      label: '联联',
      value: CouponBusinessScene.LIANLIAN,
      grantType: [
        CouponGrantType.TICKET,
        CouponGrantType.PHONE_NUMBER,
        CouponGrantType.USER_ID,
        CouponGrantType.COUPON_BAG
      ]
    },
    {
      label: '保险',
      value: CouponBusinessScene.INSURANCE,
      grantType: [CouponGrantType.TICKET, CouponGrantType.DEPOT_ID]
    },
    {
      label: '优惠券',
      value: CouponBusinessScene.ZDS,
      grantType: [CouponGrantType.PHONE_NUMBER, CouponGrantType.USER_ID]
    }
  ],

  // 优惠券发放类型
  couponGrantType: [
    { label: '兑换券', value: CouponGrantType.TICKET },
    { label: '手机号发放', value: CouponGrantType.PHONE_NUMBER },
    { label: '用户编码发放', value: CouponGrantType.USER_ID },
  ],

  activityZdsType: [
    {
      label: '指定商品',
      value: ZdsActivityType.GOODS
    },
    {
      label: '全部商品',
      value: ZdsActivityType.All
    }
  ],

  // 发放类型
  CouponAppointType: [
    { label: '手机号发放', value: 2},
    { label: '用户编辑发放', value: 3 }
  ],

  // 下发门店状态
  opIssueStoreStatus: [
    { label: '长期账号', value: 2 },
    { label: '门店认证未通过且装修认证未通过且非长期账号', value: 3 },
    { label: '门店认证通过且装修认证通过', value: 4 },
    { label: '门店认证通过且装修认证未通过', value: 1 },
    { label: '门店认证未通过且装修认证通过', value: 5 }
  ],

  //门店装修认证类型
  renovationType: [
    { label: 'A', value: 'A' },
    { label: 'B', value: 'B' },
    { label: 'C', value: 'C' },
    { label: 'D', value: 'D' },
    { label: 'E', value: 'E' },
    { label: 'F', value: 'F' },
    { label: 'G', value: 'G' },
    { label: 'Y', value: 'Y' },
    { label: 'H', value: 'H' }
  ],

  //工单首次下发对象
  // opDistributionObject: [
  //   { label: '服务商/城市经理', value: 0 },
  //   { label: '门店', value: 1, disabled: true }
  // ],
  opDistributionObject: [
    { label: '服务商', value: 2 },
    { label: '城市经理', value: 3 },
    { label: '门店', value: 1, disabled: true }
  ],

  // 网点垫资装修门店 打款状态
  opAdvanceFundPayStatus: [
    { label: '未打款', value: OperateAdvanceFundPayStatus.UNPAID },
    { label: '已打款', value: OperateAdvanceFundPayStatus.PAID }
  ],

  // 网点垫资装修门店 新增状态
  opAdvanceFundAddStatus: [
    { label: '处理中', value: OperateAdvanceFundAddStatus.PENDING },
    { label: '新增失败', value: OperateAdvanceFundAddStatus.FAILED },
    { label: '新增成功', value: OperateAdvanceFundAddStatus.SUCCESS }
  ],

  // 运营/任务管理/审核类型
  opAuditBizTypes: [
    { label: '试用账号', value: OperateFlowBizType.TRIAL_ACCOUNT },
    { label: '门店认证', value: OperateFlowBizType.STORE_CERT },
    { label: '装修认证', value: OperateFlowBizType.DECORATION_CERT },
    { label: '门店退出', value: OperateFlowBizType.STORE_QUIT },
    { label: '门店转让', value: OperateFlowBizType.DEVICE_TRANSFER }
  ],

  // 运营流程简单审核状态
  opAuditSimpleApproveStatus: [
    { label: '审核中', value: OperateSimpleApproveStatus.PENDING },
    { label: '审核通过', value: OperateSimpleApproveStatus.PASS },
    { label: '审核未通过', value: OperateSimpleApproveStatus.REJECT }
  ],

  // 运营流程审核状态
  opAuditApproveStatus: [
    { label: '待审核', value: OperateKdcsApproveStatus.PENDING },
    { label: '预审通过', value: OperateKdcsApproveStatus.ISP_PASS },
    { label: '预审不通过', value: OperateKdcsApproveStatus.ISP_NOT_PASS },
    { label: '初审通过', value: OperateKdcsApproveStatus.CITY_MANAGER_PASS },
    { label: '初审不通过', value: OperateKdcsApproveStatus.CITY_MANAGER_NOT_PASS },
    { label: '终审驳回', value: OperateKdcsApproveStatus.HQ_REJECT },
    { label: '终审通过', value: OperateKdcsApproveStatus.HQ_PASS },
    { label: '终审不通过', value: OperateKdcsApproveStatus.HQ_NOT_PASS }
  ],
  // 24小时门店审核状态
  opAuditApproveStatus3: [
    { label: '待审核', value: OperateKdcsApproveStatus.PENDING },
    { label: '初审通过', value: OperateKdcsApproveStatus.CITY_MANAGER_PASS },
    { label: '初审不通过', value: OperateKdcsApproveStatus.CITY_MANAGER_NOT_PASS },
    { label: '终审通过', value: OperateKdcsApproveStatus.HQ_PASS },
    { label: '终审不通过', value: OperateKdcsApproveStatus.HQ_NOT_PASS }
  ],
  // 拨测状态
  opAuditPhoneCallStatus: [
    { label: '待拨测', value: PhoneCallStatus.PENDING },
    { label: '拨测成功', value: PhoneCallStatus.PASS },
    { label: '拨测失败', value: PhoneCallStatus.FAIL }
  ],

  // 运营流程审核状态
  opAuditApproveStatus2: [
    { label: '待审核', value: OperateKdcsApproveStatus.PENDING },
    { label: '终审通过', value: OperateKdcsApproveStatus.HQ_PASS },
    { label: '终审不通过', value: OperateKdcsApproveStatus.HQ_NOT_PASS }
  ],

  // 设备补贴审核状态
  opAuditDeviceSubsidyApproveStatus: [
    { label: '待审核', value: OperateSimpleApproveStatus.PENDING },
    { label: '初审通过', value: OperateKdcsApproveStatus.CITY_MANAGER_PASS },
    { label: '初审不通过', value: OperateKdcsApproveStatus.CITY_MANAGER_NOT_PASS },
    { label: '终审通过', value: OperateKdcsApproveStatus.HQ_PASS },
    { label: '终审不通过', value: OperateKdcsApproveStatus.HQ_NOT_PASS },
    { label: '已拒绝', value: OperateKdcsApproveStatus.HQ_REFUSE }
  ],

  // 设备补贴类型
  opAuditDeviceSubsidyType: [
    { label: '一类', value: 'A' },
    { label: '二类', value: 'B' },
    { label: '三类', value: 'C' },
    { label: '置换类', value: 'D' }
  ],
  // 补贴类型
  allowanceType: [
    { label: '设备补贴 ', value: 2 },
    { label: '新增门店补贴', value: 7 },
    { label: '智能货架补贴', value: 8 }
  ],
  // 门店转让审核状态
  opAuditStoreTransferApproveStatus: [
    { label: '待审核', value: OperateKdcsApproveStatus.PENDING },
    { label: '预审通过', value: OperateKdcsApproveStatus.ISP_PASS },
    { label: '预审不通过', value: OperateKdcsApproveStatus.ISP_NOT_PASS },
    { label: '终审通过', value: OperateKdcsApproveStatus.CITY_MANAGER_PASS },
    { label: '终审不通过', value: OperateKdcsApproveStatus.CITY_MANAGER_NOT_PASS }
  ],

  // 补贴风控审核状态
  opAuditRiskSubsidyApproveStatus: [
    { label: '审核中', value: 1 },
    { label: '补贴中', value: 2 },
    { label: '审核不通过', value: 3 },
    { label: '已补贴', value: 4 },
    { label: '已拒绝', value: 5 },
    { label: '审核通过', value: 6 }
  ],

  // 门店信息修改审核状态
  opAuditStoreUpdateApproveStatus: [
    { label: '待审核', value: OperateKdcsApproveStatus.PENDING },
    { label: '预审通过', value: OperateKdcsApproveStatus.ISP_PASS },
    { label: '预审不通过', value: OperateKdcsApproveStatus.ISP_NOT_PASS },
    { label: '初审通过', value: OperateKdcsApproveStatus.CITY_MANAGER_PASS },
    { label: '初审不通过', value: OperateKdcsApproveStatus.CITY_MANAGER_NOT_PASS },
    { label: '终审通过', value: OperateKdcsApproveStatus.HQ_PASS },
    { label: '终审不通过', value: OperateKdcsApproveStatus.HQ_NOT_PASS }
  ],

  // 活动报名审核状态
  opAuditActivityRegistractionStatus: [
    { label: '待审核', value: 0 },
    { label: '审核通过', value: 1 },
    { label: '审核不通过', value: 2 }
  ],

  // 末端备案回执状态
  opAuditFilingReceiptStatus: [
    { label: '待审核', value: 0 },
    { label: '审核通过', value: 60 },
    { label: '审核不通过', value: 70 }
  ],

  // 短信模版审核状态
  opAuditSmsTemplateApproveStatus: [
    { label: '审核中', value: 0 },
    { label: '审核通过', value: 1 },
    { label: '审核未通过', value: -1 }
  ],

  // 门店临关审核状态
  opAuditStoreTemporaryCloseApproveStatus: [
    { label: '初始状态', value: 0 },
    { label: '审核中', value: 1 },
    { label: '审核通过', value: 2 },
    { label: '审核不通过', value: 3 },
    { label: '不需要审核', value: 4 }
  ],
  opDecorationCertVillageStoreTypes: [
    { label: '其他', value: 0 },
    { label: '进村门店', value: 1 },
    { label: '校园门店', value: 2 },
    { label: '社区合营', value: 3 },
    { label: '社区专营', value: 4 },
    { label: '乡镇门店', value: 5 }
  ],
  // 门店操作人类型
  opStoreTemporaryCloseOperationType: [
    { label: '门店自主操作', value: 0 },
    { label: '管理员操作', value: 1 },
    { label: '系统自动操作', value: 2 }
  ],

  // 门店临关类型
  opStoreTemporaryCloseOperateType: [
    { label: '开启临关', value: 0 },
    { label: '解除临关', value: 1 }
  ],

  opAuditSmsTypes: [
    { label: '入库模板', value: 'SMS_TEMPLATE' },
    { label: '催提模板', value: 'URGED_TEMPLATE' }
  ],

  // 运营/任务管理/审核类型
  opAuditTrailTypes: [
    { label: '七天试用', value: 0 },
    { label: '永久试用', value: 1 }
  ],

  villageStoreList: [
    { label: '其他', value: 0 },
    { label: '进村门店', value: 1 },
    { label: '校园门店', value: 2 },
    { label: '社区合营', value: 3 },
    { label: '社区专营', value: 4 },
    { label: '乡镇门店', value: 5 }
  ],

  // 门店清退类型
  opStoreQuitTypes: [
    { label: '门店申请退出', value: 1 },
    { label: '城市经理清退', value: 2 },
    { label: '总部清退', value: 3 },
    { label: '风控清退', value: 4 }
  ],

  // 门店清退类型
  operateStoreQuitTypes: [
    { label: '门店申请退出', value: 1 },
    { label: '城市经理清退', value: 2 }
  ],

  // 门店清退状态
  opStoreQuitClearStatus: [
    { label: '待清退', value: OperateStoreQuitClearStatus.PENDING },
    { label: '已清退', value: OperateStoreQuitClearStatus.QUITED }
  ],
  //门店列表-门店类型
  tuxiStoreType: [
    { label: '兔喜标店', value: 1 },
    { label: '兔喜小店', value: 2 },
    { label: '长期账号', value: 3 },
    { label: '未认证', value: 0 },
    { label: '兔喜普店', value: 4 }
  ],
  // 门店列表-门店认证状态
  authStatus: [
    { label: '未申请', value: 0 },
    { label: '审核中', value: 20 },
    { label: '审核通过', value: 30 },
    { label: '审核不通过', value: 10 }
  ],
  // 门店列表-装修认证状态
  renovationAuthStatus: [
    { label: '未申请', value: 0 },
    { label: '审核中', value: 20 },
    { label: '审核通过', value: 30 },
    { label: '审核不通过', value: 10 }
  ],
  // 门店列表-临关状态
  temporarilyClosedStatus: [
    { label: '未启动', value: 0 },
    { label: '临关生效中', value: 1 },
    { label: '临关待生效', value: 2 },
    { label: '临关审核中', value: 3 },
    { label: '解除临关审核中', value: 4 }
  ],
  // 门店列表-退出状态
  quitStatusList: [
    { label: '未申请', value: 0 },
    { label: '退出清算中', value: 30 },
    { label: '退出审核中', value: 20 },
    { label: '退出审核不通过', value: 10 },
    { label: '已退出', value: 60 }
  ],

  // 门店列表-保证金状态
  marginStatus: [
    { label: '是', value: 1 },
    { label: '否', value: 0 }
  ],

  //门店列表-入库限制
  opWarehouseLimit: [
    { label: '已限制', value: 0 },
    { label: '未限制', value: 1 }
  ],

  //门店列表-补贴类型
  opSubsidyTypes: [
    { label: '装修补贴', value: 1 },
    { label: '设备补贴申请', value: 2 },
    { label: '指数补贴', value: 3 },
    { label: '设备补贴结算', value: 4 },
    { label: '装修升级补贴', value: 5 },
    { label: '门店补贴申请', value: 6 },
    { label: '门店补贴结算', value: 7 },
    { label: '智能货架补贴申请', value: 8 },
    { label: '智能货架补贴结算', value: 9 }
  ],

  //门店列表-末端备案状态
  opFilingReceiptStatus: [
    { label: '未备案', value: 0 },
    { label: '备案审核不通过', value: 10 },
    { label: '备案审核中', value: 20 },
    { label: '已备案', value: 30 },
    { label: '备案即将过期', value: 35 },
    { label: '已过期', value: 36 },
    { label: '备案异常', value: 40 }
  ],

  // 补贴申请明细-补贴类型 （比所有补贴类型少了设备补贴结算）
  opSubsidyAppliesSubsideTypes: [
    { label: '装修补贴', value: 1 },
    { label: '设备补贴申请', value: 2 },
    { label: '指数补贴', value: 3 },
    { label: '装修升级补贴', value: 5 },
    { label: '新增门店补贴', value: 7 },
    { label: '智能货架补贴', value: 8 }
  ],

  //门店列表-补贴状态
  opSubsidyStatus: [
    { label: '未申请', value: 0 },
    { label: '审核中', value: 3 },
    // { label: '审核不通过', value: -1 }, // 审核不通过不会出现在补贴申请明细中
    { label: '已补贴', value: 2 },
    { label: '补贴中', value: 1 },
    { label: '已拒绝', value: -30 },
    { label: '已作废', value: -40 }
  ],

  //门店列表-选择时间
  opSubsidyTime: [
    // { label: '补贴申请时间', value: 1 },
    { label: '拨款到账时间', value: 2 },
    { label: '补贴到账时间', value: 3 },
    { label: '补贴审核时间', value: 4 }
  ],

  //门店巡检记录-巡检类型
  opGiveOutType: [
    { label: '日常巡检', value: 1 },
    { label: '工单下发巡检', value: 2 }
  ],
  //门店巡检记录-巡检状态
  opFlowStatus: [
    { label: '待接单', value: 0 },
    { label: '未完成', value: 12 },
    { label: '已超时', value: 15 },
    { label: '已完成', value: 30 },
    { label: '异常上报', value: 25 }
  ],

  // 门店巡检记录-拜访状态
  // 全部、拜访中、正常、异常、已超时
  // 拜访状态 1:拜访中、2:正常、3:异常、4:已超时
  opVisitingStatus: [
    { label: '拜访中', value: 1 },
    { label: '正常', value: 2 },
    { label: '异常', value: 3 },
    { label: '已超时', value: 4 }
  ],

  //工单报表-工单完结方式
  opworksheetCompletionMethod: [
    { label: '执行人需到店', value: 1 },
    { label: '执行人不需到店', value: 0 }
  ],

  //工单报表-工单首次下发对象
  opworksheetDistributionObject: [
    // { label: '服务商/城市经理', value: 0 },
    // { label: '门店', value: 1 }
    { label: '服务商', value: 2 },
    { label: '城市经理', value: 3 },
    { label: '门店', value: 1 }
  ],

  //门店状态详情表-门店状态
  opStorestatusdetailsStoreType: [
    { label: '未认证', value: 0 },
    { label: '长期账号', value: 3 },
    { label: '兔喜标店', value: 1 },
    { label: '兔喜小店', value: 2 },
    //{ label: '门店临关', value: "" },
    { label: '门店退出', value: 60 }
  ],

  //门店状态详情表-统计日期
  opStorestatusdetailsStatisticalDate: [
    { label: '昨日', value: 0 },
    { label: '近7天', value: 1 },
    { label: '近14天', value: 2 },
    { label: '近30天', value: 3 },
    { label: '近90天', value: 4 }
  ],

  //门店综合指数报表-选择日期
  opStorecompositeindexreportDatetype: [
    { label: '按日', value: 0 },
    { label: '按月', value: 1 }
  ],

  // 门店风控类型
  opStoreRiskType: [
    { label: '设备风控', value: 1 },
    { label: '装修风控', value: 2 },
    { label: '潜在风控', value: 4 },
    { label: '操作风控', value: 8 },
    { label: '代签账号', value: 16 },
    { label: '双系统', value: 32 },
    { label: '老店新开', value: 64 }
  ],

  // 门店风控状态
  opStoreRiskStatus: [
    { label: '未解除', value: OpStoreRiskStatus.UNCLEARED },
    { label: '已解除', value: OpStoreRiskStatus.CLEARED }
  ],

  // 满意度收集点类型
  opSatCollectionPointStyles: [{ label: '弹窗', value: OpSatCollectionPointStyles.DIALOG }],

  // 满意度收集点状态
  opSatCollectionPointStatus: [
    { label: '已上线', value: OpSatCollectionPointStatus.ONLINE },
    { label: '未上线', value: OpSatCollectionPointStatus.OFFLINE }
  ],

  opRouterMap: {
    2: {
      title: '门店试用审核',
      name: 'kt.operate.audit.kdcs.trialAccount',
      path: '/operate/audit/kdcs/trialAccount',
      perm: 'kt.operate.audit.kdcs.trialAccount'
    },
    3: {
      title: '门店认证审核',
      name: 'kt.operate.audit.kdcs.storeCert',
      path: '/operate/audit/kdcs/storeCert',
      perm: 'kt.operate.audit.kdcs.storeCert'
    },
    4: {
      title: '装修认证审核',
      name: 'kt.operate.audit.kdcs.decorationCert',
      path: '/operate/audit/kdcs/decorationCert',
      perm: 'kt.operate.audit.kdcs.decorationCert'
    },
    5: {
      title: '保证金明细',
      name: 'kt.operate.store.deposit',
      path: '/operate/store/deposit',
      perm: 'kt.operate.store.deposit'
    },
    6: {
      title: '门店退出审核',
      name: 'kt.operate.audit.kdcs.storeQuit',
      path: '/operate/audit/kdcs/storeQuit',
      perm: 'kt.operate.audit.kdcs.storeQuit'
    },
    7: {
      title: '门店清退管理',
      name: 'kt.operate.store.quit',
      path: '/operate/store/quit',
      perm: 'kt.operate.store.quit'
    }
  },

  // 满意度---------------------------
  satCollectionPointTimePeriods: [...Array(24).keys()].map(v => {
    const value = `${v}:00:00-${v}:59:59`
    return { value, label: value }
  }),

  satSceneApps: [{ label: '快递超市App', value: '快递超市App' }],

  // 财务---------------------------
  // 财务/账户角色
  finAccountRoles: [
    { label: '门店', value: 'SHOP' },
    { label: '供应商', value: 'SUPPLIER' },
    { label: 'BD', value: 'BD' },
    { label: '主体', value: 'SUBJECT' }
  ],

  // 财务/账户余额类型
  finBalanceTypes: [
    { label: '补贴余额', value: 'SUBSIDY' },
    { label: '押金余额', value: 'DEPOSIT' },
    { label: '收入余额', value: 'INCOME' },
    { label: '营销余额', value: 'MARKETING' }
  ],

  // 财务/交易类型
  finTransactionTypes: [
    { label: '补贴专款充值', value: 'SUBSIDY_RECHARGE' },
    { label: '补贴专款发放', value: 'SUBSIDY_TRANSFER' },
    { label: '门店补贴流入', value: 'SHOP_SUBSIDY_IN', SUBSIDY_IN: true },
    { label: '设备补贴专款发放', value: 'DEVICE_SUBSIDY_TRANSFER' },
    { label: '门店设备补贴流入', value: 'SHOP_DEVICE_SUBSIDY_IN', SUBSIDY_IN: true },
    { label: '门店指数补贴流入', value: 'SHOP_INDEX_SUBSIDY_IN', SUBSIDY_IN: true },
    { label: '指数补贴专款发放', value: 'INDEX_SUBSIDY_TRANSFER' },
    { label: '门店补贴提现', value: 'SHOP_SUBSIDY_WITHDRAW' },
    { label: '设备补贴分期发放', value: 'DEVICE_SUBSIDY_PERIOD_TRANSFER' },
    { label: '门店设备补贴分期流入', value: 'SHOP_DEVICE_SUBSIDY_PERIOD_IN', SUBSIDY_IN: true },
    { label: '装修补贴差价专款发放', value: 'UPGRADE_SUBSIDY_TRANSFER' },
    { label: '装修补贴差价流入', value: 'SHOP_UPGRADE_SUBSIDY_IN', SUBSIDY_IN: true },
    { label: '送货上门补贴专款发放', value: 'DELIVER_SUBSIDY_TRANSFER' },
    { label: '送货上门补贴流入', value: 'SHOP_DELIVER_SUBSIDY_IN', SUBSIDY_IN: true },
    { label: '标杆店补贴发放', value: 'SAMPLE_SUBSIDY_TRANSFER' },
    { label: '标杆店补贴流入', value: 'SAMPLE_SUBSIDY_IN', SUBSIDY_IN: true }
  ],

  // 财务/业务处理/账户角色
  accountRole: [
    { label: '主体', value: 'SUBJECT' },
    { label: '门店', value: 'SHOP' },
    { label: 'BD', value: 'BD' },
    { label: '供应商', value: 'SUPPLIER' }
  ],

  // 财务/处理状态(机构回单)
  handleStatus: [
    { label: '待处理', value: 'WAIT_HANDLE' },
    { label: '处理中', value: 'APPLY_RECEIPT' },
    { label: '处理成功', value: 'ACQUIRED_RECEIPT' }
  ],

  // 财务/处理状态(百望推票)
  handleStatusBaiWang: [
    { label: '待处理', value: 'ACQUIRED_RECEIPT' },
    { label: '处理中', value: 'APPLY_BILLING' },
    { label: '处理成功', value: 'REQUESTED_BILLING' },
    { label: '处理失败', value: 'FAIL_BILLING' }
  ],

  // 财务/开票查询结果(百望推票明细)
  invoiceQueryStatus: [
    { label: '未查询', value: 1 },
    { label: '查询失败', value: 2 },
    { label: '查询成功', value: 3 }
  ],

  // 财务/发票类型(百望推票明细)
  invoiceType: [
    { label: '普通电子发票', value: 1 },
    { label: '普通纸质发票', value: 2 }
  ],

  // 财务/支付渠道
  payChannel: [
    { label: '支付宝', value: 'ALIPAY' }
    // { label: '微信支付', value: 1 },
    // { label: '易宝支付', value: 2 },
    // { label: '银行卡', value: 3 }
  ],

  // 结算审核状态
  finSettlementAuditStatus: [
    { label: '待审核', value: 'UN_AUDIT' },
    { label: '审核通过', value: 'AUDIT_PASS' },
    { label: '审核驳回', value: 'AUDIT_REJECT' }
  ],

  // 是否风控门店
  isRiskStore: [
    { label: '是', value: 0 },
    { label: '否', value: 1 }
  ],

  // 规则类型
  systemRuleTypes: [
    { label: '规则类型11', value: 11 },
    { label: '规则类型22', value: 22 }
  ],

  // 规则节点
  systemRuleNodes: [
    { label: '规则节点11', value: 11 },
    { label: '规则节点22', value: 22 }
  ],

  // 参数类型
  systemParamTypes: [
    { label: '参数类型11', value: 11 },
    { label: '参数类型22', value: 22 }
  ],

  // 参数配置-状态
  systemProcessParamsStatus: [
    { label: '启用', value: EnableStatus.ENABLE },
    { label: '停用', value: EnableStatus.DISABLE }
  ],

  // 系统 门店参数配置 新增状态
  systemStoreParamsAddStatus: [
    { label: '新增失败', value: SystemStoreParamsAddStatus.FAILED },
    { label: '新增成功', value: SystemStoreParamsAddStatus.SUCCESS }
  ],

  // 系统 >> 操作日志  操作类型
  systemOperateLogTypes: [
    { label: '新增', value: OperateType.ADD },
    { label: '修改', value: OperateType.MODIFY },
    { label: '删除', value: OperateType.DELETE }
  ],
  // 上门服务费结算-结算状态
  operateSettleStatus: [
    { label: '未结算', value: OperateSettleStatus.NO_SETTLE },
    { label: '结算中', value: OperateSettleStatus.PENDING },
    { label: '已结算', value: OperateSettleStatus.SUCCESS }
  ],

  // 上门服务费结算-时间
  operateSettleTime: [
    { label: '统计时间', value: 1 },
    { label: '打款操作时间', value: 2 },
    { label: '财务结算时间', value: 3 }
  ],

  // 上门服务费结算-调整类型
  operateAdjustType: [
    { label: '补款', value: '0' },
    { label: '扣款', value: '1' }
  ],

  // 上门服务费结算-审核状态
  operateAuditStatus: [
    { label: '审核中', value: OperateAuditStatus.PENDING },
    { label: '审核通过', value: OperateAuditStatus.SUCCESS },
    { label: '审核不通过', value: OperateAuditStatus.FAILED }
  ],

  // 是否
  decorateAuthType: [
    { label: '是', value: 2 },
    { label: '否', value: 1 }
  ],

  // 批量解除临关-配置类型
  closeTypeList: [
    { label: '按门店编号', value: 2 },
    { label: '按批次号', value: 1 }
  ],

  // 城市指标管理-指标类型
  indexTypeList: [
    { label: '门店规模指标', value: 1 },
    { label: '渗透率指标', value: 2 }
  ],

  // 送货上门订单数据-快件类型
  waybillType: [
    { label: '中通标快', value: OperateWaybillType.STANDARD },
    { label: '中通尊享', value: OperateWaybillType.VIP }
  ],

  // 标杆店账单结算-时间
  operateBenchmarkBillTime: [
    { label: '账单创建日期', value: 1 },
    { label: '确认打款日期', value: 2 },
    { label: '财务结算日期', value: 3 }
  ],

  // 意向点状态
  intentionStatus: [
    { label: '正常', value: 0 },
    { label: '删除', value: 1 }
  ],

  // 扣款状态 0、扣款中 1、扣款成功 -1 扣款失败
  operateDeductionStatus: [
    { label: '扣款中', value: 0 },
    { label: '扣款成功', value: 1 },
    { label: '扣款失败', value: -1 }
  ],

  // 保证金扣款-保证金状态
  operateMarginStatus: [
    { label: '是', value: OpMarginStatus.YES },
    { label: '否', value: OpMarginStatus.NO }
  ],

  // 操作日志-操作类型
  operateLogOperateType: [
    { label: '修改名称', value: 1 },
    { label: '修改地址', value: 2 },
    { label: '修改负责人信息', value: 3 },
    { label: '修改末端备案', value: 4 },
    { label: '修改门牌号', value: 5 },
    { label: '装修形象特批', value: 7 },
    { label: '门店联系电话', value: 8 },
    { label: '门店负责人手机号', value: 9 },
    { label: '门店打标', value: 10 },
    { label: '修改24小时门店认证', value: 11 }
  ],

  // 操作日志-操作状态
  operateLogOperateStatus: [
    { label: '成功', value: 1 },
    { label: '失败', value: 2 }
  ],
  // 承包区化门店审核列表-申报人类型
  opSubmitUserType: [
    { label: '门店', value: 1 },
    { label: '运营', value: 2 }
  ],
  // 承包区化门店审核列表-审核状态
  opNodeDetailsStatusList: [
    { label: '待审核', value: OperateKdcsApproveStatus.PENDING },
    { label: '初审通过', value: OperateKdcsApproveStatus.CITY_MANAGER_PASS },
    { label: '初审不通过', value: OperateKdcsApproveStatus.CITY_MANAGER_NOT_PASS },
    { label: '终审通过', value: OperateKdcsApproveStatus.HQ_PASS },
    { label: '终审不通过', value: OperateKdcsApproveStatus.HQ_NOT_PASS }
  ],
  // 承包区化门店审核列表-考核状态
  opExamStatus: [
    { label: '待开始', value: 0 },
    { label: '考核中', value: 1 },
    { label: '考核完成', value: 2 },
    { label: '考核未完成', value: 3 }
  ],
  // 门店拨测明细
  opCallStatus: [
    { label: '待呼叫', value: 9 },
    { label: '呼叫中', value: 0 },
    { label: '呼叫成功', value: 1 },
    { label: '呼叫失败', value: 2 }
  ],
  // 监测状态
  opMonitorStatus: [
    { label: '待执行', value: 0 },
    { label: '监测通过', value: 1 },
    { label: '监测不通过', value: 2 },
    { label: '监测超时', value: 3 }
  ],
  // 申请类型
  opApplicationType: [
    { label: '门店信息修改', value: 'kdcs-store-update' },
    { label: '门店认证', value: 'kdcs-store-auth' }
  ],
  // 复核状态
  opRecheckStatus: [
    { label: '待复核', value: 0 },
    { label: '复核通过', value: 1 },
    { label: '复核不通过', value: 2 }
  ],

  // 客服 - 工单状态
  ComplainWorkorderStatus: [
    { label: '待分配', value: ComplainWorkorderStatus.UNASSIGNED },
    { label: '待处理', value: ComplainWorkorderStatus.PENDING },
    { label: '处理中', value: ComplainWorkorderStatus.PROCESSING, tag: 'change' },
    { label: '已解决', value: ComplainWorkorderStatus.RESOLVED, tag: 'change' },
    { label: '已关闭', value: ComplainWorkorderStatus.CLOSED, tag: 'change' }
  ],

  // 客服 - 业务类型
  ComplainBusinessType: [
    // { label: 'B端门店咨询工单', value: 'kc01' },
    // { label: '快递柜咨询工单', value: 'dg01' }
    { label: '4000587000', value: '4000587000' }
  ],

  // 客服 - 紧急程度
  ComplainDegreeUrgency: [
    { label: '普通', value: ComplainDegreeUrgency.COMMON },
    { label: '紧急', value: ComplainDegreeUrgency.EMERGENCY }
  ],

  // 寄件订单 - 快递公司
  // ZTONET:中通(大网) YTO:圆通 STO:申通 YUNDA:韵达 ZTO:网点/业务员/快递员
  ComplainExpressName: [
    { label: '中通', value: 'ZTONET' },
    { label: '韵达', value: 'YUNDA' },
    { label: '圆通', value: 'YTO' },
    { label: '申通', value: 'STO' },
    { label: '网点/业务员/快递员', value: 'ZTO' }
  ],

  // 寄件订单 - 查询类型
  ComplainDateType: [
    { label: '运单号', value: 1 },
    { label: '发件手机号', value: 2 }
  ],

  // 消费者投诉处理 - 投诉渠道
  ComplainConsumerChannel: [
    { label: '微信支付', value: ComplainConsumerChannel.WECHATPAY },
    { label: '支付宝', value: ComplainConsumerChannel.ALIPAY },
    { label: '微信小程序', value: ComplainConsumerChannel.WECHATMINIPROGRAM }
  ],

  // 消费者投诉处理 - 投诉单状态
  ComplainConsumerStatus: [
    { label: '待处理', value: ComplainConsumerStatus.PENDING },
    { label: '处理中', value: ComplainConsumerStatus.PROCESSING },
    { label: '已处理', value: ComplainConsumerStatus.RESOLVED }
  ],

  // 量本利科目维护 - 计算属性
  QcpComputeType: [
    { label: '手动录入', value: QcpComputeType.MANUAL_ENTRY },
    { label: '系统取值', value: QcpComputeType.SYSTEM },
    { label: '合计', value: QcpComputeType.TOTAL }
  ],

  // 学习任务配置 - 跳转类型
  todoTaskJumpModel: [
    { label: 'H5', value: TodoTaskJumpModel.JUMP_H5 },
    { label: 'RN', value: TodoTaskJumpModel.JUMP_RN },
    { label: '原生', value: TodoTaskJumpModel.JUMP_APP }
  ],

  // 幸运大抽奖-活动状态
  lotteryActivityStatus: [
    { label: '未发布', value: ActivityStatus.NOT_PUBLISHED },
    { label: '未开始', value: ActivityStatus.PUBLISHED_NOT_EXECUTED },
    { label: '进行中', value: ActivityStatus.PUBLISHED_PENDING },
    { label: '已结束', value: ActivityStatus.PUBLISHED_END },
    { label: '已撤销', value: ActivityStatus.REVOKED }
  ],

  // 经营老板管理-超期支付订单-交易状态
  // 订单状态 0、未发起支付 1、支付中 2、支付成功 3、支付失败 4、退款中 5、退款成功 6、退款失败 7、订单关闭
  bossTradeStatus: [
    { label: '支付中', value: 1 },
    { label: '支付成功', value: 2 },
    { label: '支付失败', value: 3 },
    { label: '订单关闭', value: 7 },
    { label: '未发起支付', value: 0 },
    { label: '退款中', value: 4 },
    { label: '退款成功', value: 5 },
    { label: '退款失败', value: 6 }
  ],

  // 经营老板管理-超期支付订单-交易类型
  // 交易类型  bossRefund 退款 pickUpExpress 支付
  bossTradeType: [
    { label: '支付', value: 'pickUpExpress' },
    { label: '退款', value: 'bossRefund' }
  ],
  // 经营老板管理-合作商-合作商类型
  agentType: [
    { label: '一级代理', value: AgentLevel.ONE },
    { label: '二级代理', value: AgentLevel.TWO },
    { label: '三级代理', value: AgentLevel.THREE }
  ],
  //兔喜账号体系
  systemType: [
    { label: '中通总部', value: 'zto_hq' },
    { label: '兔喜', value: 'tuxi' }
  ],
  // 经营老板管理-室内柜分润明细-扣款状态
  debitStatus: [
    { label: '扣款成功', value: DebitStatus.SUCCESS },
    { label: '扣款失败', value: DebitStatus.FAILED },
    { label: '扣款中', value: DebitStatus.PENDING }
  ],
  // 售后工单-上报角色
  aftermarketSubmitRole: [
    { label: '门店', value: 1 },
    { label: '业务员/网点', value: 2 },
    { label: '经营老板', value: 3 },
    { label: '合作商', value: 4 },
    { label: '总部', value: 5 },
    { label: '客服', value: 6 }
  ],
  // 售后工单-处理状态
  aftermarketWorkOrderStatus: [
    { label: '待分单', value: AftermarketWorkOrderStatus.UNSHARE },
    { label: '待确认', value: 50 },
    { label: '待派单', value: AftermarketWorkOrderStatus.UNDISPATCH },
    { label: '待处理', value: AftermarketWorkOrderStatus.PENDING },
    { label: '处理中', value: AftermarketWorkOrderStatus.PROCESSING },
    { label: '已处理', value: AftermarketWorkOrderStatus.PROCESSED },
    { label: '已归档', value: AftermarketWorkOrderStatus.FILED },
    { label: '已挂起', value: AftermarketWorkOrderStatus.HUNGED },
    { label: '已撤销', value: AftermarketWorkOrderStatus.CANCELLED }
  ],
  // 售后工单-维保状态
  // aftermarketMaintenanceStatus: [
  //   { label: '维保中', value: 1 },
  //   { label: '维保失效', value: 0 },
  // ],
  // 售后工单-设备品牌
  aftermarketDeviceBrand: [
    { label: '门店', value: 1 },
    { label: '业务员/网点', value: 2 },
    { label: '经营老板', value: 3 },
    { label: '合作商', value: 4 },
    { label: '总部', value: 5 }
  ],
  // 紧急程度
  aftermarketWorkOrderLevel: [
    { label: '普通', value: AftermarketWorkOrderLevel.NORMAL },
    { label: '紧急', value: AftermarketWorkOrderLevel.URGENT }
  ],
  aftermarketExpressCompanyList: [
    { label: '中通快递', value: 'ZTO' },
    { label: '圆通快递', value: 'YTO' },
    { label: '申通快递', value: 'STO' },
    { label: '顺丰快递', value: 'SF' },
    { label: '韵达快递', value: 'YUNDA' },
    { label: '德邦快递', value: 'DEBANG' },
    { label: '百世快递', value: 'BAISHI' },
    { label: 'EMS', value: 'EMS' },
    { label: '宅急送', value: 'ZAIJISONG' },
    { label: '优速快递', value: 'UC' },
    { label: '快捷快递', value: 'KJ' },
    { label: '安能快递', value: 'ANE' },
    { label: '天天快递', value: 'TT' },
    { label: '京东', value: 'JD' },
    { label: '天猫超市', value: 'TMALL' },
    { label: '其他快递', value: 'OTHER' },
    { label: '中国邮政', value: 'ChinaPost' },
    { label: '苏宁物流', value: 'SUNING' },
    { label: '唯品会', value: 'WPH' },
    { label: '品骏', value: 'PJ' },
    { label: '极兔速递', value: 'JTSD' },
    { label: '丰网速运', value: 'FENGWANG' },
    { label: '丹鸟物流', value: 'DN' }
  ],
  // 销售订单状态
  salesOrderStatus: [
    { label: '待确认', value: SalesOrderStatus.WAIT_CONFIRM },
    { label: '已确认', value: SalesOrderStatus.CONFIRMED },
    { label: '待审核', value: SalesOrderStatus.WAIT_CHECK },
    { label: '待提交', value: SalesOrderStatus.WAIT_SUBMIT },
    { label: '待排产', value: SalesOrderStatus.WAIT_SCHEDULING },
    { label: '已关闭', value: SalesOrderStatus.CLOSED_ORDER },
    { label: '待接单', value: SalesOrderStatus.WAIT_PURCHASE },
    { label: '待发货', value: SalesOrderStatus.WAIT_DELIVERY },
    { label: '全部发货', value: SalesOrderStatus.ALL_DELIVERY },
    { label: '待验收', value: SalesOrderStatus.WAIT_SIGN },
    { label: '退货待申请', value: SalesOrderStatus.WAIT_RETURN },
    { label: '退货中', value: SalesOrderStatus.RETURNING },
    { label: '退货成功（全部）', value: SalesOrderStatus.SCUESS_RETURN_ALL },
    { label: '退货成功（部分）', value: SalesOrderStatus.SCUESS_RETURN_PART },
    { label: '已完成', value: SalesOrderStatus.COMPLETED }
  ],
  // 退货订单状态
  returnOrderStatus: [
    { label: '待申请', value: ReturnOrderStatus.WAIT_RETURN },
    { label: '关闭退货', value: ReturnOrderStatus.CLOSE_RETURN },
    // { label: '退货中已售后', value: ReturnOrderStatus.RETURNING_AFTERSALE },
    // { label: '退货中已完成退货单号', value: ReturnOrderStatus.RETURNING_RETURNED },
    { label: '退货中', value: ReturnOrderStatus.RETURNING },
    { label: '退货成功（全部）', value: ReturnOrderStatus.SCUESS_RETURN_ALL },
    { label: '退货成功（部分）', value: ReturnOrderStatus.SCUESS_RETURN_PART },
    { label: '退货失败', value: ReturnOrderStatus.FAIL_RETURN }
  ],
  // 中天结算审核-审核状态
  bossSettleZTAuditStatus: [
    { label: '待审核', value: BossSettleZTAuditStatus.WAITING },
    { label: '审核中', value: BossSettleZTAuditStatus.PENDING },
    { label: '审核通过', value: BossSettleZTAuditStatus.PASS },
    { label: '审核不通过', value: BossSettleZTAuditStatus.REJECT }
  ],
  // 中天结算审核-主订单状态
  bossSettleZTOrderStatus: [
    { label: '已申请', value: BossSettleZTOrderStatus.REQUESTED },
    { label: '进行中', value: BossSettleZTOrderStatus.ONGOING },
    { label: '已终止', value: BossSettleZTOrderStatus.TERMINATED },
    { label: '已归档', value: BossSettleZTOrderStatus.ARCHIVED }
  ],
  // 中天结算列表-详情-扣款明细-结算状态
  bossSettleZTSettleStatus: [
    { label: '待结算', value: BossSettleZTSettleStatus.WAIT_SETTLE },
    { label: '结算中', value: BossSettleZTSettleStatus.SETTLING },
    { label: '结算成功', value: BossSettleZTSettleStatus.SETTLE_SUCCESS },
    { label: '结算失败', value: BossSettleZTSettleStatus.SETTLE_FAIL },
    { label: '结算回调失败', value: BossSettleZTSettleStatus.SETTLE_CALLBACK_FAIL },
    { label: '已作废', value: BossSettleZTSettleStatus.SETTLE_CANCEL }
  ],

  blackListDataSource: [
    { label: '门店', value: BlackListDataSource.STORE },
    { label: '中通总部', value: BlackListDataSource.ZTOHEADQUARTERS },
    { label: '兔喜总部', value: BlackListDataSource.HEADQUARTERS }
  ],

  activityJumpType: [
    { label: '跳转单品详情', value: ActivityJumpType.GOODS_DETAIL },
    { label: '跳转其他页面', value: ActivityJumpType.OTHER }
  ],

  categoryStatus: [
    { label: '上架', value: 'grounding' },
    { label: '下架', value: 'off_shelf' }
  ],
  /** 活动轮播顺序 */
  activityCarouselSort: getNumberRangeDataOptions(1, 5),

  /** 活动轮播时长 */
  activityTimeSort: getNumberRangeDataOptions(2, 5),

  activityPlace: [
    {
      label: '首页顶图',
      value: ActivityPlace.BANNER_TOP,
      effectiveType: true,
      sort: true,
      headImage: { label: '活动头图', aspectLimit: [750, 850] },
      jumpUrl: true,
      cycleType: true,
      activitySort: true
    },
    // { label: '活动位1', value: ActivityPlace.BANNER2_LEFT, headTitle: true, headImage: { aspectLimit: [200, 94] } },
    // { label: '活动位2', value: ActivityPlace.BANNER2_RIGHT, headTitle: true, headImage: { aspectLimit: [112, 94] } },
    // {
    //   label: '爱库存品牌活动',
    //   value: ActivityPlace.AKC_BRAND_LIST,
    //   headImage: { aspectLimit: [189, 30] },
    //   countdown: true,
    //   bizType: ActivityBizType.ACTIVITY
    // },
    {
      label: '左侧瓷片',
      value: ActivityPlace.BANNER2_LEFT,
      headImage: { label: '头图', aspectLimit: [126, 30] },
      jumpUrl: true
      // pageHeadImage: {},
      // bgColor: true
    },
    {
      label: '右侧瓷片1',
      value: ActivityPlace.BANNER2_RIGHT,
      headImage: { label: '头图', aspectLimit: [126, 30] },
      jumpUrl: true

      // headImage: { aspectLimit: [126, 30] },
      // // displayImage: { aspectLimit: [294, 199] },
      // displayContent: true,
      // countdown: true,
      // jumpType: true,
      // bizType: ActivityBizType.GOODS
    },
    {
      label: '右侧瓷片2',
      value: ActivityPlace.BANNER_MIDDLE,
      headImage: { label: '头图', aspectLimit: [126, 30] },
      jumpUrl: true
      // headImage: { aspectLimit: [126, 30] },
      // bizType: ActivityBizType.ACTIVITY
    },
    {
      label: '横向商品瓷片',
      value: ActivityPlace.AKC_BRAND_LIST,
      effectiveType: true,
      bizType: ActivityBizType.GOODS
      // headImage: { label: '活动头图', aspectLimit: [554, 300] },
      // jumpUrl: true,
      // cycleType: true,
      // activitySort: true,
    },

  ],
  // 快递公司
  expressCompanyOpts: [
    { label: '中通快递', value: 'ZTO' },
    { label: '圆通快递', value: 'YTO' },
    { label: '申通快递', value: 'STO' },
    { label: '韵达快递', value: 'YUNDA' },
    { label: '顺丰速运', value: 'SF' },
    { label: '德邦', value: 'DEBANG' },
    { label: '百世快递', value: 'BAISHI' },
    { label: 'EMS', value: 'EMS' },
    { label: '宅急送', value: 'ZAIJISONG' },
    { label: '京东', value: 'JD' },
    { label: '中国邮政', value: 'ChinaPost' },
    { label: '极兔速递', value: 'JTSD' },
  ]
}
